<template>
  <div class="checkboxChoice">
    <span>
      <input
        id="all"
        v-model="store.allUniversSelected"
        class="checkbox"
        type="checkbox"
        aria-describedby="productUniverse"
        aria-controls="productUniverse"
        value="all"
        @change="changeUniverse"
      />
      <label for="all">All</label>
    </span>
    <span v-for="univers in universesList" :key="univers._id">
      <input
        :id="univers.universName"
        v-model="store.productUniverses"
        class="checkbox"
        type="checkbox"
        name="productUniverse"
        :value="univers.universName"
        @change="changeUniverse"
      />
      <label :for="univers.universName">{{ univers.universName }}</label>
    </span>
  </div>
</template>

<script>
import Store from "@/store";

export default {
  props: {
    clearSelection: {
      type: Function,
      required: true
    },
    universesList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      store: Store.state
    };
  },
  methods: {
    changeUniverse(event) {
      Store.changeUniverse(event.target.value, this.universesList);
      this.clearSelection();
    }
  }
};
</script>

<style lang="scss" scoped>
.checkboxChoice {
  span {
    display: flex;
    flex-direction: row;
    text-align: left;
    align-items: center;
  }
  .checkbox {
    -webkit-appearance: none;
    background-color: #fafafa;
    border: 3px solid #b9b9b9;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
      inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
    width: 24px;
    height: 24px;
    padding: 9px;
    border-radius: 30px;
    display: inline-block;
    position: relative;
    margin-right: 5px;
    margin-top: -10px;
    vertical-align: middle;
    &:hover {
      cursor: pointer;
    }
    &:focus {
      outline: none;
    }
    &:checked {
      border: 3px solid #d36c48;
    }
  }
}
</style>
